import { render, staticRenderFns } from "./WarnWork.vue?vue&type=template&id=4c5f4e0c&scoped=true&"
import script from "./WarnWork.vue?vue&type=script&lang=js&"
export * from "./WarnWork.vue?vue&type=script&lang=js&"
import style0 from "./WarnWork.vue?vue&type=style&index=0&id=4c5f4e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f4e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5f4e0c')) {
      api.createRecord('4c5f4e0c', component.options)
    } else {
      api.reload('4c5f4e0c', component.options)
    }
    module.hot.accept("./WarnWork.vue?vue&type=template&id=4c5f4e0c&scoped=true&", function () {
      api.rerender('4c5f4e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/WarnWork.vue"
export default component.exports